import { render, staticRenderFns } from "./home-statistics-mini.vue?vue&type=template&id=696513ae&"
import script from "./home-statistics-mini.vue?vue&type=script&lang=ts&"
export * from "./home-statistics-mini.vue?vue&type=script&lang=ts&"
import style0 from "./home-statistics-mini.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports